<template>
	<div class="row">
		<div class="col-12 mb-4 d-flex flex-row align-items-center flex-wrap">
			<h1>{{ $t("placement-events") }}</h1>
        <template v-if="!showFilters">
			<button
				class="btn btn-outline-secondary ml-auto mr-2"
				@click="() => { $refs.timetable.scrollToToday() }"
			>
				{{  $t('go-to-current-week') }}
			</button>
			<button
				class="btn mr-2"
				:class="denseView ? 'btn-secondary' : 'btn-outline-secondary'"
				@click="denseView = !denseView"
			>
				{{ denseView ? $t('full-calendar') : $t('back') }}
			</button>

            <!-- Toggle filters -->
            <button
                class="btn mr-2"
                :class="showFilters ? 'btn-primary' : 'btn-outline-secondary'"
                @click="showFilters = true"
            >
                <b-icon icon="filter" class="mr-1" />{{ $t('filters') }}
            </button>

            <button
				class="btn btn-outline-primary mr-2"
				@click="$router.push('/timetables/placement-provider')"
			>
				{{$t('time-report')}}
			</button>
			<button
				:disabled="!placementevents.length || !students.length"
				class="btn btn-primary"
				@click="downloadCSV"
			>
				{{$t('download')}}
			</button>
        </template>
		</div>

        <!-- Filter sidebar -->
		<div class="formeditor__sidebar"
			v-if="loaded"
			v-show="showFilters"
		>
			<div class="mb-2">
				<button class="btn btn-outline-secondary" @click="--zoom" :disabled="zoom<=1"><b-icon icon="zoom-out"></b-icon></button>
				<button class="btn btn-outline-secondary ml-2" @click="++zoom" :disabled="zoom>=3"><b-icon icon="zoom-in"></b-icon></button>
				<button type="button" class="btn ml-2" :class="slimRows ? 'btn-primary' : 'btn-outline-secondary'" @click="slimRows = !slimRows">
					{{ $t('slim-rows') }}
				</button>
				<button class="btn btn-light btn-xs float-right"
				   @click="showFilters = false"><b-icon icon="x" width="1em" height="1em"></b-icon></button>
			</div>
			<!--div class="mb-2">
				<button v-if="this.firm" type="button" class="btn ml-auto btn-outline-danger" @click="$router.replace({ query: { ...$route.query, firm: undefined }})">
					<b-icon icon="x" class="mr-1"/>{{ $t('firm') }} {{  $config.getValue('firms')[this.firm] }}
				</button>
			</div-->     
			<AdminFilters
				ref="filters"
				:timetable="placementspan"
				:selectedYears="showYears"
				@updateYears="val => showYears = val"
				:allGroups="groups"
				:selectedGroups="showGroups"
				@updateGroups="val => showGroups = val"
				:allRooms="rooms"
				:selectedRooms="showRooms"
				@updateRooms="val => showRooms = val"
				:selectedUsers="showStudents"
				@updateUsers="val => showStudents = val"
				@searchRoomsOnDate="val => selectStudentsInRoomsOnDate(val)"
				@slimRows="val => slimRows = val"
                :isPlacementTT="true"
			/>
           
		</div>

		<template v-if="loaded">
			<AdminTimetable
				v-if="placementevents.length && students.length"
				ref="timetable"
				class="col-12 mb-4"
				:events="placementevents"
				:from="from"
				:until="until"
				:students="showStudents.length ? showStudents : placementspan.students"
                :years="showYears.filter(y => y.programme_id == programme.Id).map(y => y.year)"
				:groups="(showGroups.length ? showGroups : groups).filter(gr => gr.programme_id == programme.Id)"
				:programme="programme"
                :rooms="showRooms"
				:dense="denseView"
				:allowStudentViewAlways="true"
				:studentViewOnLoad="true"
                :zoom="zoom"
                :slim="slimRows"
                @showYear="y => showYears = [{programme_id: programme.Id, year: y}]"
				@showGroup="g => showGroups = [g]"
			/>

			<div v-else class="col-12 mb-4">
				<div class="alert alert-info">{{$t('no-results')}}</div>
			</div>
		</template>
		<template v-else>
			<div class="col-12">
				<div class="skeleton midnight h20 w100 mr-4 mb-3 float-left" v-for="n in 100" :key="n" />
			</div>
		</template>

	</div>
</template>

<script>
import AdminTimetable from 'src/components/Timetables/AdminTimetable.vue';
import AdminFilters from "src/components/Timetables/AdminFilters.vue";
import SessionManager from "src/modules/session/sessionManager";
import {dateToISODate} from "src/modules/timetable/util"

export default {
	components: {
		AdminTimetable,
AdminFilters
	},
	mounted() {
        const from = this.$route.query.from ? this.$route.query.from : this.sessionManager.get('from-date') ? this.sessionManager.get('from-date') : null
		const until = this.$route.query.to ? this.$route.query.to : null;

        if (this.$route.query.from || this.$route.query.to) history.replaceState(null, '', this.$route.path.split('?')[0])

        this.getPlacements(from, until);
	},
	data() {
		return {
            zoom: 3,
			submitting: false,
            filters: {
                page: 1,
                page_size: 3000,
                datefrom: '',
                dateto: '',
            },
			placementevents: [],
			loaded: false,
			showselected: null,
			eventContainer: null,
			from: null,
			until: null,
			students: [],
			groups: [],
			programme: null,
			denseView: true,
            rooms: [],

            placementspan: {},

            // Filters
			showFilters: false,
			filterByGroups: false,
			showGroups: [],
			showYears: [],
			showRooms: [],
			showStudents: [],
			slimRows: false,
			collapseWeekends: false,
			collapseEmptyDates: false,
			filterFrom: this.$route.query.from,
			filterTo: this.$route.query.to,
			roomSearchDate: '',
            sessionManager: new SessionManager(this.$route),
            studentsByUserId: {},
		}
	},
	methods: {
		getPlacements(from = null, to = null) {
			this.loaded = false;
			let filters = {
                ...this.filters,
                datefrom: from,
                dateto: to
            }
			if (this.$UserSession.hasPriv('TIMETABLE_ADMIN')) {
				filters.provider_id = this.$route.query.provider_id
			}

            this.$cfetch(`${this.$settings.APIBaseURL}/placements/myplacements`, {
				cache: false,
				method: 'GET',
                data: filters,
			}).then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Error fetching placements')

				this.placementevents = res.results
				this.filters.page = res.pagination.page
				this.filters.page_size = res.pagination.page_size
				this.filters.total = res.pagination.total

				const from = this.placementevents.reduce((item, curr) => {
					return item.from < curr.from ? item : curr
				}, this.placementevents[0]).from

				const to = this.placementevents.reduce((item, curr) => {
					return item.to > curr.to ? item : curr
				}, this.placementevents[0]).to

				this.from = new Date(Number(from)*1000).toISOString().split('T')[0]
				this.until = new Date(Number(to)*1000).toISOString().split('T')[0]

                this.placementspan = {
                    datefrom: this.from,
                    dateto: this.until
                }

                const uniqueTtrooms= new Map(
                    this.placementevents.map(event => [event.ttroom.id, event.ttroom])
                );

                this.rooms = Array.from(uniqueTtrooms.values());
        

                this.placementspan = {
                    datefrom: this.from,
                    dateto: this.until
                }
        

				this.processEvents();
				this.loaded = true;
			}).catch(error => {
				this.$log.error.call(this, error)
			})
		},
		processEvents() {
			this.$users.getStudents.call(this).then(users => {
				const usersById = users.reduce((prev, curr) => {
					prev[curr.id] = {
						id: curr.id,
						displayname: curr.displayName,
						programme_id: curr.programme,
						year: curr.year,
						group_id: curr.group,
					}
					return prev
				}, {})

				const students = {}
				const allGroups = {}

				this.placementevents = this.placementevents.map(event => {
					let eventGroups = {}

					event.students = event.students.map(user => {
						let student = usersById[user.id]
						if (!student) return user

						let key = `${student.programme_id}-${student.year}-${student.group_id}`
						let gr = {
							id: key,
							group_id: student.group_id,
							year: student.year,
                            programme_id: student.programme_id,
							title: this.$config.getValue('groups')[student.group_id],
						}

						allGroups[key] = gr
						eventGroups[key] = gr
						students[student.id] = student

						return student
					})

					event.groups = Object.values(eventGroups)
					return event
				})

				this.students = Object.values(students)
				this.groups = Object.values(allGroups)

                this.placementspan = {
                    students: this.students,
                    groups: this.groups
                }

				if (this.students.length) this.programme = this.$config.getValue('programmes')[this.students[0].programme_id]
			})
		},
        toPage(pageNo) {
            this.filters.page = pageNo
            this.getPlacements()
        },
		downloadCSV() {
            let students = this.showStudents.length ? this.showStudents : this.placementspan.students;

            if(this.showGroups.length) {
                const group_ids = this.showGroups.map(x => {return x.id}); // id returns programme_id-year-group_id
                
                students = students.filter(x => {
                    return group_ids.includes(`${x.programme_id}-${x.year}-${x.group_id}`)
                })
            }
            
            if(this.showYears.length){
                const programme_year_ids = this.showYears.map(x => {return `${x.programme_id}-${x.year}`});

                students = students.filter(x => {return programme_year_ids.includes(`${x.programme_id}-${x.year}`)})
            } 

            const csv = 'data:text/csv;charset=utf-8,' 
            + this.$refs.timetable.eventContainer.getCSV(students,
                {
                    'Name': 'displayname'
                }, 
                (events)=> {return events[0].title + ' - ' + events[0].ttroom.name}
            )
			const el = document.createElement('a')
			el.href = csv
			el.setAttribute('download', 'placements.csv')
			el.click()
		},
		downloadPlacements(){
			window.open(
				`${this.$settings.APIBaseURL}/placements/myplacements?username=${this.$UserSession.getValue.call(
					this,
					"username"
				)}&authToken=${this.$UserSession.getValue.call(
					this,
					"authToken"
				)}&download=pdf`
			);
		},
        /**
		 * @param {string} date YYYY-MM-DD
		 */
		loadEarlier(date) {
			if (this.submitting || date < this.timetable.datefrom) return Promise.resolve()

			let from = new Date(...date.split('-').map((val, i) => i === 1 ? Number(val)-1 : Number(val)))
			from.setDate(from.getDate() - 28) // We're doing 4-week chunks
			return this.fetchEvents(dateToISODate(from))
		},
        /**
		 * @param {string} date YYYY-MM-DD
		 */
		async selectStudentsInRoomsOnDate(date) {
			this.$refs.timetable.forEach(tt => tt.clearEvents())
			await this.fetchEvents(date)
			this.loadEarlier(date)

			this.showStudents = []

			this.$refs.timetable.forEach(tt => {
				const ids = tt.eventContainer.getStudentsWhere((key) => {
					return key === date
				}, (events) => {
					for (const event of events) {
						if (!event.ttroom_id) return false
						for (const room of this.showRooms) if (room.id == event.ttroom_id) return true
					}
					return false
				})

				for (const id of ids) this.showStudents.push(this.studentsByUserId[id])

				tt.studentView = true
			})

			if (!this.showStudents.length) return

			this.showFilters = false
			this.showRooms = []
			this.showYears = []
			this.showGroups = []
		},
	},
};
</script>
